/**
 * Frontend JavaScript for modal functionality
 */

(function () {
	'use strict';

	// Store active modal
	let activeModal = null;

	/**
	 * Initialize all leadership modules on the page
	 */
	function initLeadershipModules() {
		// Get all leadership buttons
		const buttons = document.querySelectorAll(
			'.leadership-button[data-modal-target]'
		);

		buttons.forEach((button) => {
			// Remove any existing listeners to prevent duplicates
			button.removeEventListener('click', handleButtonClick);
			// Add click listener
			button.addEventListener('click', handleButtonClick);
		});

		// Get all close triggers
		const closeElements = document.querySelectorAll('[data-modal-close]');
		closeElements.forEach((element) => {
			element.removeEventListener('click', handleCloseClick);
			element.addEventListener('click', handleCloseClick);
		});

		// ESC key to close modal
		document.removeEventListener('keydown', handleEscKey);
		document.addEventListener('keydown', handleEscKey);
	}

	/**
	 * Handle button click to open modal
	 */
	function handleButtonClick(e) {
		e.preventDefault();
		const modalId = this.getAttribute('data-modal-target');
		const modal = document.getElementById(modalId);

		if (modal) {
			openModal(modal);
		}
	}

	/**
	 * Handle close button/overlay click
	 */
	function handleCloseClick(e) {
		e.preventDefault();
		const modal = this.closest('.leadership-modal');
		if (modal) {
			closeModal(modal);
		}
	}

	/**
	 * Handle ESC key press
	 */
	function handleEscKey(e) {
		if (e.key === 'Escape' && activeModal) {
			closeModal(activeModal);
		}
	}

	/**
	 * Open a modal
	 */
	function openModal(modal) {
		// Close any currently open modal
		if (activeModal && activeModal !== modal) {
			closeModal(activeModal);
		}

		// Open the new modal
		modal.classList.add('is-open');
		document.body.classList.add('leadership-modal-open');
		activeModal = modal;

		// Focus trap - focus first focusable element in modal
		setTimeout(() => {
			const focusableElements = modal.querySelectorAll(
				'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
			);
			if (focusableElements.length > 0) {
				focusableElements[0].focus();
			}
		}, 100);
	}

	/**
	 * Close a modal
	 */
	function closeModal(modal) {
		modal.classList.remove('is-open');
		document.body.classList.remove('leadership-modal-open');

		// Return focus to the button that opened the modal
		const modalId = modal.getAttribute('id');
		const button = document.querySelector(
			`[data-modal-target="${modalId}"]`
		);
		if (button) {
			button.focus();
		}

		activeModal = null;
	}

	/**
	 * Initialize on DOM ready
	 */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLeadershipModules);
	} else {
		initLeadershipModules();
	}
})();
